function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "opacity",
  opacity: 0.4,
  d: "M14.4083 6.608C13.9833 6.608 13.4205 6.59859 12.7197 6.59859C11.0105 6.59859 9.60522 5.184 9.60522 3.45882V0.432C9.60522 0.193882 9.41511 0 9.17933 0H4.20106C1.8778 0 0 1.90682 0 4.24376V14.3849C0 16.8367 1.96727 18.8235 4.3949 18.8235H11.8083C14.1231 18.8235 16 16.9289 16 14.5901V7.03153C16 6.79247 15.8108 6.59953 15.5741 6.60047C15.1762 6.60329 14.699 6.608 14.4083 6.608Z",
  fill: "#C4C4C4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "opacity",
  opacity: 0.4,
  d: "M11.8438 0.533306C11.5623 0.2406 11.071 0.442012 11.071 0.847659V3.32954C11.071 4.37048 11.9285 5.22695 12.9694 5.22695C13.6254 5.23448 14.5365 5.23636 15.3101 5.23448C15.7063 5.23354 15.9078 4.76013 15.6329 4.47401C14.64 3.44154 12.8621 1.59119 11.8438 0.533306Z",
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "white",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.1519 8.83501H8.33778C8.7246 8.83501 9.03895 8.52159 9.03895 8.13477C9.03895 7.74795 8.7246 7.43359 8.33778 7.43359H5.1519C4.76507 7.43359 4.45166 7.74795 4.45166 8.13477C4.45166 8.52159 4.76507 8.83501 5.1519 8.83501ZM5.152 13.5374H10.2758C10.6626 13.5374 10.9769 13.224 10.9769 12.8372C10.9769 12.4504 10.6626 12.136 10.2758 12.136H5.152C4.76517 12.136 4.45176 12.4504 4.45176 12.8372C4.45176 13.224 4.76517 13.5374 5.152 13.5374Z",
  fill: "#C4C4C4"
});

function SvgApi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.8ae87ab0.svg";
export { ForwardRef as ReactComponent };